import {useCallback, useEffect, useState} from 'react'
import axios from 'axios'
import {useAuth} from '../auth'

// Disparado pela lista de tickets quando algo muda (fechar ticket, criar tarefa), para o alerta
// do menu lateral atualizar na hora em vez de esperar o próximo ciclo.
const PORTAL_TICKETS_CHANGED_EVENT = 'portal-tickets-changed'
const REFRESH_INTERVAL_MS = 60000

const notifyPortalTicketsChanged = () =>
  window.dispatchEvent(new Event(PORTAL_TICKETS_CHANGED_EVENT))

// Quantidade de tickets ABERTOS (aguardando o time) do Portal do Cliente: alimenta o alerta
// piscando do menu lateral. Só conta o status "open": ticket em andamento já está sendo tratado.
const useOpenPortalTicketsCount = () => {
  const {auth} = useAuth()
  const token = auth?.api_token
  const [count, setCount] = useState(0)

  const refresh = useCallback(async () => {
    if (!token || document.hidden) return

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/client-portal-tickets`,
        {
          params: {status: 'open', per_page: 1},
          headers: {Authorization: `Bearer ${token}`},
        }
      )
      setCount(response.data?.pagination?.total ?? 0)
    } catch (err) {
      // Módulo fora do plano (404), sem permissão ou API fora do ar: sem alerta.
      setCount(0)
    }
  }, [token])

  useEffect(() => {
    refresh()
    const intervalId = window.setInterval(refresh, REFRESH_INTERVAL_MS)
    window.addEventListener('focus', refresh)
    window.addEventListener(PORTAL_TICKETS_CHANGED_EVENT, refresh)

    return () => {
      window.clearInterval(intervalId)
      window.removeEventListener('focus', refresh)
      window.removeEventListener(PORTAL_TICKETS_CHANGED_EVENT, refresh)
    }
  }, [refresh])

  return count
}

export {useOpenPortalTicketsCount, notifyPortalTicketsChanged}
